<template>
  <div class="supplierPage">
    <div v-if="storeList.num !== 0">
      <div class="top">
        <span>全部结果</span>
        <span class="searchNum">
          共
          <span style="color: #ec212d">{{ storeList.num }}</span> 个厂家
        </span>
      </div>
      <MySizer
        ref="sizer"
        :val="1"
        :is-district="1"
        :is-field="1"
        :city.sync="city"
        :slot-item="slotItem"
        @onCity="onCity"
        @lookUp="onScreen"
        @onDistrict="onDistrict($event)"
      >
        <span slot="1">综合</span>
      </MySizer>
      <div v-if="storeList.store.length > 0">
        <div
          v-for="(item, index) in storeList.store"
          :key="index"
          class="storeList"
        >
          <div class="shop-left">
            <div class="storeName">
              <span>
                <svg-icon
                  style="width: 23px; height: 19px"
                  icon-class="shouyedianpu"
                />
                {{ item.name }}
              </span>
              <div class="storeButton" @click="toShop(item.id)">进入店铺</div>
            </div>
            <div class="storeGood">
              <span class="store-start">
                <svg-icon class="store-start-item" icon-class="start-yellow" />
                <svg-icon class="store-start-item" icon-class="start-yellow" />
                <svg-icon class="store-start-item" icon-class="start-yellow" />
                <svg-icon class="store-start-item" icon-class="start-yellow" />
                <svg-icon class="store-start-item" icon-class="start-yellow" />
                <span class="starLevel">5.0星</span>
              </span>

              <svg-icon class="address-icon" icon-class="address" />
              <span class="store-address">{{ item.address }}</span>
            </div>
            <div class="inspectButton">
              <svg-icon icon-class="investigate" />
            </div>
            <div class="line" />
            <div class="storeProduct">
              <span style="color: #999">主营产品：</span>
              <span
                v-for="(val, index) in item.product"
                :key="index"
                class="name"
              >{{ val }}</span>
            </div>
          </div>
          <div class="shop-right">
            <div class="right-li-box">
              <div
                v-for="(it, indexs) in item.stockList"
                :key="indexs"
                class="right-li"
                @click="goDetails(it)"
              >
                <img v-if="it.FCover" class="li-img" :src="it.FCover" alt="">
                <img
                  v-else
                  class="li-img"
                  src="../../../assets/images/no-pic.jpg"
                  alt=""
                >
                <div class="shop-name">{{ it.FStockName }}</div>
                <div class="shop-price">
                  <span class="fprice FstorePrice">
                    ￥{{ it.fStockPrice }}</span>
                  <s class="fprice">￥{{ FixedTo(it.FPrice) }}</s>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="storeList.store.length > 0">
        <el-pagination
          style="text-align: center"
          background
          layout="prev, pager, next"
          :current-page.sync="Collect.pageNo"
          :page-size.sync="Collect.pageSize"
          :total="Collect.total"
          @current-change="CollectSear(false)"
        />
      </template>
      <div v-else class="shopNone">
        <img src="@/assets/images/no-data.png" alt>
        <p>未能搜索到符合条件的商品，请重新选择区域！</p>
      </div>
    </div>
  </div>
</template>
<script>
import MySizer from '@/components/sizer/index.vue'
import quest from '../api/supplierPage'
export default {
  components: {
    MySizer
  },
  data() {
    return {
      Collect: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      constName: '', // 检索名
      slotItem: [{}],
      storeList: {
        num: 59,
        store: [
          // {
          //   name: "实达实工业品官方自营店",
          //   address: "浙江省衢州市",
          //   product: ["五金机电", "传感器", "除绣器"]
          // },
        ]
      },
      city: {
        hotCity: [],
        cityItem: []
      },
      look: false,
      area: {}
    }
  },
  watch: {
    $route: {
      handler(val) {
        this.clear()
        this.searchLink(val.query.search)
      },
      deep: true
    }
  },
  mounted() {
    this.searchLink(this.$route.query.search)
    quest.WebArea().then((res) => {
      this.$set(this.city, 'cityItem', res.data)
    })
  },
  methods: {
    FixedTo(num) {
      const str = !isNaN(Number(num)) ? Number(num).toFixed(3) : '0.00'
      const index = str.indexOf('.')
      return str.slice(0, index + 3)
    },
    goDetails(val) {
      const pathInfo = this.$router.resolve({
        path: '/store/details',
        query: {
          mallstorestockFId: val.FMallStoreStockID,
          shopid: val.FMallStoreID
        }
      })
      window.open(pathInfo.href, '_blank')
    },
    clear() {
      this.$refs.sizer.district = '区域选择'
      this.$refs.sizer.checked = false
      this.look = false
      this.area = {}
    },
    searchLink(sear) {
      this.constName = sear
      const check = {}
      //   if (this.look)
      check.FProductType = sear
      const FInspected = Number(this.look)
      quest
        .MallStore({
          pageNo: 1,
          pageSize: this.Collect.pageSize,
          jsonStr: {
            FInspected,
            FMallStoreName: sear,
            ...this.area
            // ...check
          }
        })
        .then((res) => {
          const list = res.data.records.map((item) => {
            let address = item.webareaFName
            if (item.webareaFLevelName) {
              const strlist = item.webareaFLevelName.split('\\')
              let l = ''
              let r = ''
              strlist.forEach((items) => {
                if (items.indexOf('省') > -1) {
                  l = items
                }
                if (items.indexOf('市') > -1) {
                  r = items
                }
              })
              address = l + ' ' + r
            }
            return {
              id: item.mallstoreFID,
              name: item.FMallStoreName || '',
              address: address || '',
              product: [],
              stockList: item.stockList
            }
          })
          this.Collect.pageNo = 1
          this.Collect.total = res.data.total
          this.$set(this.storeList, 'store', list)
        })
    },
    onScreen(e) {
      if (e) {
        this.look = true
      } else {
        this.look = false
      }
      this.searchLink(this.constName)
    },
    onDistrict(e) {
      if (!e || e == '区域选择') {
        this.area = {}
      } else {
        this.area = {
          webareaFName: e
        }
      }

      this.searchLink(this.constName)
    },
    onCity(city) {
      this.area = {
        webareaFTreeCode: city.code
      }
      this.searchLink(this.constName)
    },
    CollectSear(reset) {
      quest
        .MallStore({
          pageNo: this.Collect.pageNo,
          pageSize: this.Collect.pageSize,
          jsonStr: {
            FMallStoreName: this.constName
          }
        })
        .then((res) => {
          const list = res.data.records.map((item) => {
            let address = item.webareaFName
            if (item.webareaFLevelName) {
              const strlist = item.webareaFLevelName.split('\\')
              let l = ''
              let r = ''
              strlist.forEach((items) => {
                if (items.indexOf('省') > -1) {
                  l = items
                }
                if (items.indexOf('市') > -1) {
                  r = items
                }
              })
              address = l + ' ' + r
            }
            return {
              id: item.mallstoreFID,
              name: item.FMallStoreName || '',
              address: address || '',
              stockList: item.stockList,
              product: []
            }
          })
          this.$set(this.storeList, 'store', list)
        })
    },
    toShop(id) {
      quest.MallStoreNavigation(id).then((res) => {
        const data =
          res.data.find((item) => item.fnavigationName == '店铺档案') || {}
        this.$router.push({
          path: '/store/storeFile',
          query: {
            mallstorestockFId: id,
            forder: data.forder,
            storeId: id,
            fid: data.fid,
            name: '店铺档案'
          }
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.supplierPage {
  width: 100%;
  margin: 30px 0;
  .top {
    font-size: 16px;
    color: #333;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .searchNum {
      font-size: 12px;
      color: #999;
    }
  }
  .storeList {
    width: 100%;
    height: 255px;
    border: 1px solid #ffe6e6;
    display: flex;
    .shop-left {
      width: 572px;
      padding: 20px;
      margin-top: 10px;
      // background: linear-gradient(0deg, #ffe6d8, #ffffff);
      background: #fff9f9;
    }
    .shop-right {
      width: calc(100%-572px);
      height: 100%;
      .right-li-box {
        height: 100%;
        display: flex;
        .li-img {
          width: 100%;
          height: 154px;
        }
        .FstorePrice {
          font-size: 18px;
          color: #ec3351;
          margin-right: 16px;
        }
        .shop-price {
          font-size: 12px;
          color: #a2a5b5;
          margin-top: 10px;
        }
        .shop-name {
          height: 35px;
          font-size: 14px;
          font-weight: 400;
          color: #424551;
          margin-top: 10px;
          overflow: hidden;
          display: -webkit-box; /*弹性伸缩盒子*/
          -webkit-box-orient: vertical; /*子元素垂直排列*/
          -webkit-line-clamp: 2; /*可以显示的行数，超出部分用...表示*/
        }
        .right-li {
          width: 200px;
          background: #fff;
          padding: 11px;
          margin-right: 14px;
          font-size: 12px;
          cursor: pointer;
        }
      }
    }
    .storeName {
      display: flex;
      justify-content: space-between;
      font-size: 20px;
      color: #333;
      font-weight: bold;
      .storeButton {
        width: 96px;
        height: 36px;
        background: #ffffff;
        border: 1px solid #d2d2d2;
        border-radius: 4px;
        border-radius: 4px 4px 4px 4px;
        color: #ec212d;
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        line-height: 36px;
        border: 1px solid #ec212d;
        &:hover {
          border: 1px solid #ec212d;
          color: #ec212d;
          cursor: pointer;
        }
      }
    }
    .storeGood {
      padding: 10px 0 12px 0;
      .store-start {
        position: relative;
        margin-right: 24px;
        .store-start-item {
          margin-right: 2px;
        }
        &::after {
          position: absolute;
          top: 3px;
          right: -12px;
          content: "";
          height: 16px;
          width: 1px;
          background-color: #000;
          opacity: 0.1;
        }
        .starLevel {
          font-size: 16px;
          color: #ff812c;
          padding-left: 9px;
        }
      }
      .store-address {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333;
      }
      .address-icon {
        width: 13px;
        height: 13px;
        margin-right: 6px;
      }
    }
    .inspectButton {
      .svg-icon {
        width: 100px;
        height: 60px;
      }
    }
    .line {
      width: 100%;
      height: 1px;
      background: #000000;
      opacity: 0.1;
    }
    .storeProduct {
      width: 100%;
      padding-right: 160px;
      margin-top: 18px;
      font-size: 16px;
      color: #333;
      overflow: hidden; /*溢出隐藏*/
      white-space: nowrap; /*规定文本不进行换行*/
      text-overflow: ellipsis;
      .name {
        padding-left: 9px;
      }
    }
  }
  .shopNone {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 92px 0;
    img {
      width: 184px;
      height: 184px;
    }
    p {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
    }
  }
}
</style>
